import React from 'react'
// import PropTypes from 'prop-types'

import classes from './Footer.scss'

import { withTranslate } from 'react-redux-multilingual'

// import InputGroup from '../UI/Forms/InputGroup/InputGroup'
import Button from '../../../UI/Button/Button'
// import Modal from '../UI/Modal/Modal'

const buttonGroups = ({ save, another, cancel, disable, showAnother, translate }) => (
  <div className={classes.ButtonGroup}>
    <span className={classes.Button}>
      <Button color={'primary'} clicked={save} disabled={disable}>
        {translate('save')}
      </Button>
    </span>
    {showAnother ? (
      <span className={classes.Button}>
        <Button color={'primary'} clicked={another} disabled={disable}>
          {translate('saveAndAddAnother')}
        </Button>
      </span>
    ) : null}
    <span className={classes.Button}>
      <Button color={'default'} clicked={cancel}>
        {translate('cancel')}
      </Button>
    </span>
  </div>
)

export default withTranslate(buttonGroups)
